import { m } from "framer-motion";
import PatrioticLogo from "../components/PatrioticLogo";

const fade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.25 }
};

export default function Home() {
  return (
    <m.main {...fade} className="min-h-screen grid place-items-center text-center px-4">
      <PatrioticLogo />
    </m.main>
  );
}